export default function formatPhoneNumber(phoneNumber: string, ignoreUnstandardized = false): string {
  const phoneRegex = /(?<=[^\d]|^)(?:\+?(?<CountyCode>\d{1,3}))?(?:[\s-.(]*(?<AreaCode>\d{3})[\s-.)]*)(?:(?<Prefix>\d{3})[\s-.]*)(?<Line>\d{4})(?: *(?:x|ext|extension)(?<Extension>\d{1,6}))?(?=[^\d]|$)/;

  if (!phoneNumber) {
    return phoneNumber;
  }

  if (!phoneNumber.match(phoneRegex) && ignoreUnstandardized)
    return phoneNumber;

  //trim whitespace and remove any non-numeric characters
  const result = phoneNumber.trim().replace(/\D/g, "");

  //some data includes extensions and/or country codes. Only format if it's a standard 10-digit number
  return result.length === 10 ? `(${result.substr(0, 3)}) ${result.substr(3, 3)}-${result.substr(6, 4)}` : result;
}
